import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { COMPANY } from "@/data/content";

const LINKS = [
  { label: "Services", href: "/#services" },
  { label: "Zones", href: "/#zones" },
  { label: "Avis", href: "/#avis" },
  { label: "Blog", href: "/blog" },
  { label: "FAQ", href: "/#faq" },
  { label: "Contact", href: "/#contact" },
];

function Logo() {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
      <span className="grid place-items-center w-10 h-10 rounded-lg bg-brand-navy text-white font-display font-bold text-xl">
        S
      </span>
      <span className="font-display font-semibold text-sm tracking-tight leading-tight text-brand-navy">
        SERRURIER
        <span className="block text-[10px] tracking-[0.28em] text-brand-gold font-medium">
          LAGNY-SUR-MARNE
        </span>
      </span>
    </Link>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={
        "fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-500 " +
        (scrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-brand-line shadow-[0_4px_30px_-12px_rgba(10,30,63,0.15)]"
          : "bg-white/70 backdrop-blur-md border-b border-transparent")
      }
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.14em] font-medium text-brand-navy/70 hover:text-brand-navy transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${COMPANY.phoneTel}`}
            data-testid="navbar-call-btn"
            className="hidden sm:flex items-center gap-2 bg-brand-gold hover:bg-brand-golddark text-brand-navy px-5 py-2.5 rounded-full text-sm font-semibold transition-colors duration-300"
          >
            <Phone className="w-4 h-4" />
            {COMPANY.phoneDisplay}
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-brand-navy p-2"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-brand-line px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.14em] font-medium text-brand-navy"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`tel:${COMPANY.phoneTel}`}
            data-testid="mobile-call-btn"
            className="flex items-center justify-center gap-2 bg-brand-gold text-brand-navy px-5 py-3 rounded-full text-sm font-semibold"
          >
            <Phone className="w-4 h-4" /> {COMPANY.phoneDisplay}
          </a>
        </div>
      )}
    </header>
  );
}
